module.exports = __webpack_public_path__ + "static/media/04_Plutoo-Nike.339277f5.gif";